module.exports = __webpack_public_path__ + "img/3.a73bbb30.svg";